import { Component } from "../../core/Component";
// import { $ } from "../../core/dom";

export class NavBtnQuizComponent extends Component {
  constructor($root, options) {
    // console.log(options);
    $root.$el.classList.add("qform-row");
    super($root, options);
    this.$root = $root;
    this.messages = options.messages;
    this.tabNum = options.tabNum || 0;
    this.formId = options.formId;
    this.formIndex = options.formIndex;
    this.submitSetting = options.submitSetting;
    this.nameNextId = `${this.formId}_${this.formIndex}_next`;
    this.namePrevId = `${this.formId}_${this.formIndex}_prev`;
    this.nameSendId = `${this.formId}_${this.formIndex}_send`;
    this.rootBoxId = `${this.formId}_${this.formIndex}_root-box`;
    this.buttonsBoxId = `${this.formId}_${this.formIndex}_buttons-box`;
    this.boxPrevId = `${this.formId}_${this.formIndex}_prev-box`;
    this.boxNextId = `${this.formId}_${this.formIndex}_next-box`;
    this.boxSendId = `${this.formId}_${this.formIndex}_send-box`;
    this.qformLabelId = `qform-label_${this.formId}_${this.formIndex}`;
    this.qformLabelLinkId = `qform-label-link_${this.formId}_${this.formIndex}`;
    this.submitText = options.submitSetting.text;
    this.endTab = false;
    this.mode = options.mode;
    this.useDesign = options.useDesign;
    this.showCaption = options.showCaption;
    // this.showCaption = 1;
    this.captionLink = options.captionLink;
  }
  toHTML() {
    this.$root.html(`
    <div class="qform-field" id="${this.rootBoxId}">
      <div class="qform-field__quiz-btn" id="${this.buttonsBoxId}">
        <div class="qform-field__quiz-btn-box" id="${this.boxPrevId}">
          <input type="button" class="${this.useDesign ? "qform-field__quiz-btn__btn-prev" : ""}" data-action="prev" id="${this.namePrevId}" value="${this.messages.buttonPrevious}" />
        </div>
        <div class="qform-field__quiz-btn-box" id="${this.boxNextId}">
          <input type="button" class="${this.useDesign ? "qform-field__quiz-btn__btn-next" : ""}" data-action="next" id="${this.nameNextId}" value="${this.messages.buttonNext}" />
        </div>
        <div class="qform-field__quiz-btn-box" id="${this.boxSendId}">
          <input type="button" class="${this.useDesign ? "qform-field__quiz-btn__btn-send" : ""} ${this.submitSetting.class || ""}" data-action="send" id="${this.nameSendId}" value="${this.submitText}"/>
        </div>
      </div>
      ${this.showCaption ? this.getLabelHTML() : ""}
    </div>
    `);
  }
  onClickNext(e) {
    e.preventDefault();
    this.$emit("nextTab", this.tabNum);
  }
  onClickPrev(e) {
    e.preventDefault();
    this.$emit("prevBtnLoading");
    this.$emit("prevTab", this.tabNum);
  }
  onClickSend(e) {
    e.preventDefault();
    const items = localStorage.getItem(this.options.formId);
    if (items != null) {
      localStorage.removeItem(this.options.formId);
    }
    if (e.isTrusted && this.mode) {
      this.$emit("Submit:validForm", {});
    }
  }
  //отображение необходимых кнопок навигации для вкладки
  setNavBtn(tabNum, endTab) {
    this.tabNum = tabNum;
    this.endTab = endTab;
    this.toggleButtonsVisibility();
  }
  init() {
    this.$rootBox = this.$root.$el.querySelector(`#${this.rootBoxId}`);
    this.$buttonsBox = this.$root.$el.querySelector(`#${this.buttonsBoxId}`);
    this.$btnNext = this.$root.$el.querySelector(`#${this.nameNextId}`);
    this.$btnPrev = this.$root.$el.querySelector(`#${this.namePrevId}`);
    this.$btnSubmit = this.$root.$el.querySelector(`#${this.nameSendId}`);
    this.$boxPrev = this.$root.$el.querySelector(`#${this.boxPrevId}`);
    this.$boxNext = this.$root.$el.querySelector(`#${this.boxNextId}`);
    this.$boxSend = this.$root.$el.querySelector(`#${this.boxSendId}`);
    this.$qformLabel = this.$root.$el.querySelector(`#${this.qformLabelId}`);
    this.$qformLabelLink = this.$root.$el.querySelector(`#${this.qformLabelLinkId}`);
    this.listeners = [];
    this.listeners = [{
      eventName: "click",
      method: "onClickNext",
      el: this.$btnNext
    }, {
      eventName: "click",
      method: "onClickPrev",
      el: this.$btnPrev
    }, {
      eventName: "click",
      method: "onClickSend",
      el: this.$btnSubmit
    }];
    this.toggleButtonsVisibility();
    this.Emitter.subscribe("setNavBtn", this.setNavBtn.bind(this));
    this.Emitter.subscribe("Submit:disabledBtn", this.disabledSubmit.bind(this));
    this.Emitter.subscribe("Submit:addDisabledStyleBtn", this.toggleDisabledBtnStyle.bind(this));
    this.$subscribe("Submit:loading", this.toggleLoading.bind(this, "submit"));
    this.$subscribe("nextBtnLoading", this.toggleLoading.bind(this, "next"));
    this.$subscribe("nextBtnLoadingEnd", this.toggleLoading.bind(this, "next", false));
    this.$subscribe("prevBtnLoading", this.toggleLoading.bind(this, "prev"));
    this.$subscribe("prevBtnLoadingEnd", this.toggleLoading.bind(this, "prev", false));
    super.init();
    if (this.showCaption) {
      this.startLabelProtectionInterval();
    }
  }
  setClassField(data) {
    //  0 - тень, 1 - стрелочка, 2 - без ховера, 3 - смена цвета]
    let styleHover = {
      0: "shadow",
      1: "arrow",
      2: "",
      3: "opacity"
    };
    //установка классов и стилей кнопкам навигации
    const buttons = [this.$btnPrev, this.$btnNext, this.$btnSubmit];
    buttons.forEach(button => {
      if (button) {
        if (this.useDesign) {
          button.classList.add(`qform-field__quiz-btn__btn-${button.getAttribute("data-action")}`);
        } else {
          button.classList.remove(...button.classList);
        }
      }
    });
    if (data && typeof data.formStyleSubmitButton.hoverStyle !== "undefined") {
      if (data.formStyleSubmitButton.hoverStyle !== 2) {
        this.$btnNext.classList.add(`qform-field__quiz-btn__hover-${styleHover[data.formStyleSubmitButton.hoverStyle]}`);
        this.$btnSubmit.classList.add(`qform-field__quiz-btn__hover-${styleHover[data.formStyleSubmitButton.hoverStyle]}`);
      }
      //при ховере "стрелка"
      if (data.formStyleSubmitButton.hoverStyle === 1) {
        this.$boxNext.classList.add("qform__hover-arrow");
        this.$boxSend.classList.add("qform__hover-arrow");
      }
    }
    //применение стилей отключенных кнопок "Далее" и "Отправить"
    if (data && typeof data.formStyleSubmitButton.inactive !== "undefined") {
      this.disabledClass = +data.formStyleSubmitButton.inactive;
    }
  }
  validation() {
    return true;
  }
  toggleLoading(buttonName) {
    let loaderShown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    const buttonsList = {
      submit: this.$btnSubmit,
      next: this.$btnNext,
      prev: this.$btnPrev
    };
    buttonsList[buttonName].classList[loaderShown === true ? "add" : "remove"]("qform-btn-loading");
  }
  disabledSubmit(status) {
    if (this.$btnSubmit) {
      this.toggleBtnDisabled(this.$btnSubmit, status);
    }
    if (this.$btnNext) {
      this.toggleBtnDisabled(this.$btnNext, status);
    }
    if (this.$btnPrev) {
      this.toggleBtnDisabled(this.$btnPrev, status);
    }
  }
  toggleBtnDisabled($el, isDisabled) {
    if (isDisabled) {
      $el.setAttribute("disabled", "disabled");
    } else {
      $el.removeAttribute("disabled");
    }
  }
  toggleDisabledBtnStyle(isDisabled) {
    if (this.disabledClass) {
      this.$boxNext.classList[isDisabled ? "add" : "remove"]("qform-submit-disabled");
      this.$boxSend.classList[isDisabled ? "add" : "remove"]("qform-submit-disabled");
    }
  }

  //управление отображением кнопок навигации квиза
  toggleButtonsVisibility() {
    this.$btnPrev.style.display = this.$boxPrev.style.display = this.tabNum === 0 ? "none" : "inline-block";
    this.$btnNext.style.display = this.$boxNext.style.display = this.endTab ? "none" : "inline-block";
    this.$btnSubmit.style.display = this.$boxSend.style.display = this.endTab ? "inline-block" : "none";
  }
  getLabelHTML() {
    return `<p class="qform__form-label" id="${this.qformLabelId}">
      <a href="${this.captionLink}" id="${this.qformLabelLinkId}" target="_blank" rel="noopener noreferrer" title="Qform.io" class="qform__form-label__link">Создать форму</a>Создано в конструкторе Qform.io
    </p>`;
  }
  startLabelProtectionInterval() {
    this.applyForceLabelStyles();
    let interval = setInterval(() => {
      this.$qformLabel?.remove();
      this.$rootBox.insertAdjacentHTML("beforeend", this.getLabelHTML());
      this.$qformLabel = document.querySelector(`#${this.qformLabelId}`);
      this.$qformLabelLink = document.querySelector(`#${this.qformLabelLinkId}`);
      if (!this.$rootBox || !this.$qformLabel) {
        clearInterval(interval);
        return;
      }
      this.applyForceLabelStyles();
    }, 5000);
    window.addEventListener("beforeunload", () => clearInterval(interval));

    //останавливаем интервал после отправки формы
    const $formRoot = document.querySelector(`div[data-formid=${this.formId}]`);
    $formRoot.addEventListener(`qform_${this.formId}_send`, () => {
      clearInterval(interval);
    });
  }
  applyForceLabelStyles() {
    this.$qformLabel.style = "opacity: 1 !important; display: block !important; font-size: .71em !important; text-indent: 0 !important";
    this.$qformLabelLink.style = "opacity: 1 !important; display: inline !important; text-indent: 0 !important";
  }
}